/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import * as API from '../../framework/API/api'
import { DAYS, ENTITYNAME, LOCALSTORAGE_KEY, PLATFORMTYPE, PUBLISHING_SOURCE, TOAST_TYPES, VERSION_TYPE } from "../../framework/constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Grid, GRID_COL_INDEX_ATTRIBUTE, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { ArrayCell } from "../../framework/forms/helpercomponents/CustomGridCells/ArrayCell";
import { DateOnlyCell, DateTimeCell } from "../../framework/forms/helpercomponents/CustomGridCells/DateCell";
import moment from "moment";
import { useTranslation } from "../../locale/useTranslation";
import AddRoundButton from "../../framework/forms/helpercomponents/buttons/AddRoundButton";
import SaveButton from "../../framework/forms/helpercomponents/buttons/SaveButton";
import CancelButton from "../../framework/forms/helpercomponents/buttons/CancelButton";
import { ConfirmDeleteAlert } from '../../ConfirmAlert'
import { CheckboxCell } from "../../framework/forms/helpercomponents/CustomGridCells/CheckBoxCell";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { utility } from "../../framework/utility/utilityProvider";
import { HrefCell } from "../../framework/forms/helpercomponents/CustomGridCells/HrefCell";
import { stringEnumCell } from "../../framework/forms/helpercomponents/CustomGridCells/PlatformCell";
import RoundButton from "../../framework/forms/helpercomponents/buttons/RoundButton";
import { TimePickerWithFormat } from "../../framework/forms/helpercomponents/timepicker/TimePickerWithFormat";
import MyMultiSelect from "../../components/MyMultiSelect";
import BossDialog from "../../components/BossDialog";
import { useTableKeyboardNavigation } from "@progress/kendo-react-data-tools";
import CollectionSelection from "../../framework/forms/CollectionSelection";
import TooltipInfoCard from "../../components/TooltipInfoCard";
import { MenuCommandCell } from "../../framework/forms/helpercomponents/CustomGridCells/MenuCommandCell ";
import ToastNotification from "../../components/ToastNotification";
import { ContractTitleBlackoutDateEditForm } from "../Contract/ContractTitleBlackoutDateEditForm";

function MediaEpisodePublishingEditForm(props) {

  const { mediaEpisodeEntity = {} } = props;

  const lang = useTranslation();
  const currentUser = utility.getValue(LOCALSTORAGE_KEY.userData);
  const showLinearTab = props?.showLinearTab ?? true;
  const showNonLinearTab = props?.showNonLinearTab ?? true;
  const isLongUI = props?.mediaCategory?.isLong ?? false;

  const [platforms, setPlatforms] = useState([]);
  const [channels, setChannels] = useState([]);
  const [regions, setRegions] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [playTime, setPlayTime] = useState([]);
  const [tabNumber, setTabNumber] = useState(props.defaultTab ?? (showLinearTab ? "1" : "2"));
  const [systemDealRightMessage, setSystemDealRightMessage] = useState("Unlimited Rights");
  const [systemDealRight, setSystemDealRight] = useState({});
  const [isSystemCreatedCheck, setIsSystemCreatedCheck] = useState(false);
  const [isSystemCreated, setIsSystemCreated] = useState(false);
  const [showChannelGroups, setShowChannelGroups] = useState(false);
  const [showPlatformGroups, setShowPlatformGroups] = useState(false);
  const [showBlackOutDate, setShowBlackOutDate] = useState(false);
  const [gridDealRights, setGridDealRights] = useState([]);

  let blankDataItem = {
    _id: undefined,
    SID: 0,
    ContractSID: 0,
    ContractNumber: '',
    PublishStartDate: moment.utc().format('YYYY-MM-DDT00:00'),
    PublishStartDateTime: '00:00:00:00',
    PublishEndDate: moment.utc().add(50, 'year').format('YYYY-MM-DDT23:59'),
    PublishEndDateTime: "23:59:59:24",
    TimeBound: false,
    PublishingSource: props.publishingSource,
    PlatformType: tabNumber == 1 ? PLATFORMTYPE[0] : PLATFORMTYPE[1],
    Platform: [],
    Licensor: {},
    Payee: {},
    Channel: [],
    Days: DAYS,
    Region: [],
    Amount: 0,
    Currency: {},
    IsUnlimited: true,
    Exhibitions: 0,
    Repeats: 0,
    PlayTimeNumber: 0,
    MinGap: 0,
    PlayTime: {},
    IsExclusive: false,
    ExclusiveStartDate: '',
    ExclusiveEndDate: '',
    Archive: false,
    MediaCategory: props.mediaCategory ?? {},
    IsDefault: false,
    TBA: false,
    PremierStartDate: '',
    PremierEndDate: '',
    TransmissionType: {}
  }

  const [dataItem, setDataItem] = useState(blankDataItem);
  const [selectAllDays, setSelectAllDays] = useState(true);
  const [selectAllChannels, setSelectAllChannels] = useState(false);
  const [transmissionTypes, setTransmissionTypes] = useState([]);
  const [selectAllPlatforms, setSelectAllPlatforms] = useState(false);
  const [showContractAttachForm, setShowContractAttachForm] = useState(false);

  const selectedItemsRef = useRef([]);

  useEffect(() => {
    loadCombo();
  }, [tabNumber]);

  useEffect(() => {
    if (props.defaultTab) {
      setTabNumber(props.defaultTab);
    }
  }, [props.defaultTab]);

  useEffect(() => {
    loadData();
  }, []);

  const loadCombo = async () => {
    let regionRes = await API.getDataLookup(ENTITYNAME.Region, { sort: { Description: 1 } });
    setRegions(regionRes.data);
    let platformRes = await API.getDataLookup(ENTITYNAME.Platform, { sort: { Description: 1 } });
    setPlatforms(platformRes.data);
    let channelRes = await API.getValidChannels(ENTITYNAME.Channel, { sort: { FullChannelName: 1 } });
    setChannels(channelRes.data);
    let playTimeRes = await API.getDataLookup(ENTITYNAME.PlayTime, { sort: { Description: 1 } });
    setPlayTime(playTimeRes.data);

    // TRANSMISSION TYPE
    const transmissionTypesRes = await API.getDataLookup(ENTITYNAME.TransmissionTypes);
    const transmissionTypeData = transmissionTypesRes?.data?.filter(({ Name }) =>
      tabNumber == 1
        ? Name?.toLowerCase() === "linear"
        : Name?.toLowerCase() !== "linear"
    );
    setTransmissionTypes(transmissionTypeData);

    if (!editMode && transmissionTypeData?.length > 0) {
      setDataItem({ ...dataItem, TransmissionType: tabNumber == 1 ? transmissionTypeData.find(({ Name }) => Name?.toLowerCase() === "linear") : transmissionTypeData.find(({ Name }) => Name?.toLowerCase() === "svod") });
    }
  }

  const loadData = async () => {
    // fetching deal rights
    let mediaDealRights = await API.getData(ENTITYNAME.MediaDealRights, {
      query: ["media_id", "=", mediaEpisodeEntity?._id?.toString()],
    });
    let systemDealRightValue = mediaDealRights?.data?.find(x => x?.IsSystemCreated == true) ?? {};
    setSystemDealRight(systemDealRightValue);
    setIsSystemCreated(systemDealRightValue?.IsSystemCreated);
    setGridDealRights(mediaDealRights?.data?.filter(x => x?.IsSystemCreated != true) ?? []);
  }

  const onChange = (e) => {

    if (e.target.name == "TBA") {
      setDataItem({ ...dataItem, TBA: !dataItem.TBA });
    } else if (e.target.name == "TimeBound") {
      setDataItem({ ...dataItem, TimeBound: !dataItem.TimeBound });
    } else if (e.target.name == "IsUnlimited") { //need Some review
      setDataItem({
        ...dataItem,
        IsUnlimited: !dataItem.IsUnlimited,
        Exhibitions: 0,
        Repeats: 0,
        PlayTimeNumber: 0,
        PlayTime: {}
      });
    } else if (e.target.name == "IsExclusive") {
      setDataItem({
        ...dataItem,
        IsExclusive: !dataItem.IsExclusive
      });
    } else if (e.target.name == "IsDefault") {
      setDataItem({ ...dataItem, IsDefault: !dataItem.IsDefault });
    }
    else if (e.target.name == "Days") {
      if (e.target.value.length == DAYS.length) {
        setDataItem({ ...dataItem, Days: DAYS });
        setSelectAllDays(true);
      }
      else {
        setDataItem({ ...dataItem, Days: e.target.value });
        setSelectAllDays(false);
      }
    }
    else if (e.target.name === "IsAllChannels") {
      const newValue = !selectAllChannels;

      setSelectAllChannels(newValue);
      setDataItem({
        ...dataItem,
        Channel: newValue ? channels : []
      });
    } else if (e.target.name === "Channel") {
      setDataItem({ ...dataItem, [e.target.name]: e.target.value });
      if (e.target.value.length === channels.length) {
        setSelectAllChannels(true);
      } else {
        setSelectAllChannels(false);
      }

    } else if (e.target.name === "IsAllPlatforms") {
      const newValue = !selectAllPlatforms;

      setSelectAllPlatforms(newValue);
      setDataItem({
        ...dataItem,
        Platform: newValue ? platforms : [],
      });
    } else if (e.target.name === "Platform") {
      setDataItem({ ...dataItem, [e.target.name]: e.target.value });
      if (e.target.value.length === platforms.length) {
        setSelectAllChannels(true);
      } else {
        setSelectAllChannels(false);
      }

    } else {
      ;
      setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    }

  }
  
  const setBlackOutDate = (obj) => {

    let newData = gridDealRights.map((item) => {
      return (
        item._id === obj[0]._id
          ? {
            ...item,
            BlackOutDates: obj[0].BlackOutDates,
            modBy: { _id: currentUser._id, name: currentUser.name }
          }
          : item
      )
    });
    setGridDealRights(newData);
    onSave(obj[0]);
  }

  const handleTabChange = (event, newValue) => {
    setTabNumber(`${newValue}`);
    setDataItem({ ...dataItem, PlatformType: PLATFORMTYPE[parseInt(newValue) - 1] });
  };

  const isValid = (item = dataItem) => {

    console.log("item",item)

    if (!utility.isValidDate(item.PublishStartDate)) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_valid_start_date_error_message });
      return false;
    }
    if (!utility.isValidDate(item.PublishEndDate)) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_valid_end_date_error_message });
      return false;
    }
    if (item.PublishStartDate > item.PublishEndDate) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_start_date_smaller_than_end_date_media_episode_publishing_error_message });
      return false;
    }

    if (item.MinGap < 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.min_gap_error_message });
      return false;
    }

    if (!isLongUI) {
      if (!item.Channel || item.Channel.length === 0) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_channel_error_message });
        return false;
      }
      if (!item.Days || item.Days.length == 0) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_atleast_one_days_error_message });
        return false;
      }
    }
    else {
      if (Object.keys(item.PlatformType).length === 0) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_platform_type_error_message });
        return false;
      }
      else if (item.PlatformType.Description === "Linear") {
        if (item.Channel.length === 0) {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_channel_error_message });
          return false;
        }
        if (item.IsUnlimited == false) {
          if (item.Exhibitions < 1) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.exhibition_should_not_be_zero_error_message });
            return false;
          }
          // if (item.Repeats < 1) {
          // ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.repeat_should_not_be_zero_error_message });
          //   return false;
          // }
          if (item.PlayTimeNumber < 1) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.play_time_number_should_not_be_zero_error_message });
            return false;
          }
          if (Object.keys(item.PlayTime).length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_play_time_error_message });
            return false;
          }
        }
        if (item.IsExclusive) {
          if (!utility.isValidDate(item.ExclusiveStartDate)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_exclusive_start_date_error_message });
            return false;
          }
          if (!utility.isValidDate(item.ExclusiveEndDate)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_exclusive_end_date_error_message });
            return false;
          }
        }
        else return true;
      }
      else if (item.PlatformType.Description === "Non-Linear") {
        if (item.Platform.length === 0) {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_platform_error_message });
          return false;
        }
        if (item.IsExclusive) {
          if (!utility.isValidDate(item.ExclusiveStartDate)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_exclusive_start_date_error_message });
            return false;
          }
          if (!utility.isValidDate(item.ExclusiveEndDate)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_exclusive_end_date_error_message });
            return false;
          }
        }
        else return true;
      }
    }
    return true;
  }

  const editFormGrid = (data) => {

    console.log("Edit form Grid");

    if (data?.IsSystemCreated) {
      let authorizeChannel = utility.isUserAuthorizeChannelRights(data.Channel);
      if (!authorizeChannel) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.you_are_not_authorized_to_edit_this_channel_error_message });
        return;
      }
    }

    if (props?.publishingSource != PUBLISHING_SOURCE.Series && data.PublishingSource == PUBLISHING_SOURCE.Series) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.you_are_not_authorized_to_edit_please_go_to_parent_series_error_message });
      return;
    }

    if (props?.publishingSource != PUBLISHING_SOURCE.Season && data.PublishingSource == PUBLISHING_SOURCE.Season) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.you_are_not_authorized_to_edit_please_go_to_series_error_message });
      return;
    }

    if (!props?.mediaCategory?.isLong || (data?.PublishingSource == props?.publishingSource) || data?.IsSystemCreated) {

      props.setOpenPublishingDialog(true);
      setEditMode(true);

      let daysArray = data.Days ? data.Days.split(",").map((item) => DAYS.find((x) => x.ID == item)) : [];

      setDataItem({
        ...data,
        TimeBound: data.TimeBound ?? false,
        PublishStartDate: moment.utc(data.PublishStartDate).format('YYYY-MM-DDTHH:mm'),
        PublishStartDateTime: data.PublishStartDateTime ? utility.convertMilisecondsToStringWithFrames(data.PublishStartDateTime) : '00:00:00:00',
        PublishEndDate: moment.utc(data.PublishEndDate).format('YYYY-MM-DDTHH:mm'),
        PublishEndDateTime: data.PublishEndDateTime ? utility.convertMilisecondsToStringWithFrames(data.PublishEndDateTime) : "23:59:59:24",
        ExclusiveStartDate: data.IsExclusive ? moment(new Date(data.ExclusiveStartDate)).format('YYYY-MM-DD') : '',
        ExclusiveEndDate: data.IsExclusive ? moment(new Date(data.ExclusiveEndDate)).format('YYYY-MM-DD') : '',
        PremierStartDate: data.PremierStartDate ? moment(new Date(data.PremierStartDate)).format('YYYY-MM-DD') : '',
        PremierEndDate: data.PremierEndDate ? moment(new Date(data.PremierEndDate)).format('YYYY-MM-DD') : '',
        MinGap: data.MinGap ?? 0,
        Days: daysArray,
      })
      setSelectAllDays(daysArray.length == DAYS.length ? true : false);
      setSelectAllChannels(data?.Channel && data?.Channel.length > 0 && data?.Channel?.length === channels?.length ? true : false);

    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Selected Deal Right Can Be Edited From " + data.PublishingSource + " only." });
    }

    return;
  }

  const removePublishing = async (data = {}) => {

    if (props?.publishingSource != PUBLISHING_SOURCE.Series && data.PublishingSource == PUBLISHING_SOURCE.Series) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.you_delete_this_deal_right_right_from_parent_series_only_media_episode_publishing_error_message });
      return;
    }
    if (props?.publishingSource != PUBLISHING_SOURCE.Season && data.PublishingSource == PUBLISHING_SOURCE.Season) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.you_delete_this_deal_right_right_from_series_only_media_episode_publishing_error_message });
      return;
    }

    if (data.PublishingSource != PUBLISHING_SOURCE.Contract) {

      let res = await API.deleteDealRights(data?._id);
      console.log({ res });

      if (res?.success) {
        setGridDealRights(gridDealRights.filter(x => x?._id != data?._id));
        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.delete_successfully_grid_data_success_toast_message });
      } else {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
      }
    }
    else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.you_delete_this_deal_right_from_contract_only_media_episode_publishing_error_message });
    }
  }

  const onSave = async (item = dataItem) => {

    if (!isValid(item)) return;

    let publishingObject = {
      ...item,
      TimeBound: item.TimeBound ?? false,
      PublishStartDate: moment.utc(item.PublishStartDate).valueOf(),
      PublishEndDate: moment.utc(item.PublishEndDate).valueOf(),
      PublishStartDateTime: item.TimeBound ? utility.convertStringWithFramesToMilliseconds(item.PublishStartDateTime) : utility.convertStringWithFramesToMilliseconds('00:00:00:00'),
      PublishEndDateTime: item.TimeBound ? utility.convertStringWithFramesToMilliseconds(item.PublishEndDateTime) : utility.convertStringWithFramesToMilliseconds("23:59:59:24"),
      ExclusiveStartDate: item.IsExclusive ? new Date(item.ExclusiveStartDate).getTime() : 0,
      ExclusiveEndDate: item.IsExclusive ? new Date(item.ExclusiveEndDate).getTime() : 0,
      Days: item.Days && item.Days.map((item) => item.ID).join(","),
      MinGap: item.MinGap ? item.MinGap : 0,
      Channel: item?.Channel && item.Channel?.map((item) => {
        return {
          _id: item._id,
          SID: item.SID,
          FullChannelName: item.FullChannelName,
        }
      }),
      isSystemCreated: isSystemCreated ?? false,
      PremierStartDate: item.PremierStartDate ? moment.utc(item.PremierStartDate).valueOf() : null,
      PremierEndDate: item.PremierEndDate ? moment.utc(item.PremierEndDate).valueOf() : null,
      TransmissionType: item.TransmissionType?._id ? { _id: item.TransmissionType._id, SID: item.TransmissionType.SID, Name: item.TransmissionType.Name } : {}
    }

    if (isLongUI && !publishingObject.TimeBound) {
      delete publishingObject.TimeBound;
      delete publishingObject.PublishStartDateTime;
      delete publishingObject.PublishEndDateTime;
    }

    if (!mediaEpisodeEntity?._id) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_save_media_first_error_message });
      return
    }

    let resMediaDealRights = await API.createAndUpdateDealRights(publishingObject, mediaEpisodeEntity?._id);
    console.log({ resMediaDealRights });

    if (resMediaDealRights.success) {
      const savedDealRights = resMediaDealRights?.data?.[0] ?? {};
      setGridDealRights((prev) => {
        const isExist = prev.some((x) => x._id === savedDealRights?._id);
        if (isExist) {
          return prev.map((x) => x._id === savedDealRights?._id ? savedDealRights : x);
        }
        return [...prev, savedDealRights];
      });
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: resMediaDealRights.message });
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: resMediaDealRights.message });
    }

    if (isSystemCreated) {
      let getChannelName = publishingObject?.Channel?.map((item) => item?.FullChannelName).join(", ");
      let updateMessage = "Unlimited Channel Right for " + getChannelName + " Channel(s)";
      setSystemDealRightMessage(updateMessage);
    }

    clearData();
  }

  const clearData = () => {
    setDataItem(blankDataItem);
    setEditMode(false);
    props.setOpenPublishingDialog(false);
    setSelectAllDays(true);
    setSelectAllChannels(false);
    setIsSystemCreatedCheck(false);
  }

  const dealRightsMenuModel = (props) => {

    const menu = [
      {
        label: 'Options',
        items: [
          { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.onEdit(props.dataItem) },
          { label: 'Attach Contract', icon: 'pi pi-fw pi-link', command: () => props.onAttachContract(props.dataItem) },
          { label: 'Black Out Date', icon: 'pi pi-fw pi-stop-circle', command: () => props.onEditBlackOutDate(props.dataItem) },
          { label: 'Delete', icon: 'pi pi-fw pi-trash', command: () => props.onDelete(props.dataItem) },
        ]
      }
    ]

    return menu;
  }

  const onAttachContract = (dataItem) => {
    if (props?.publishingSource != PUBLISHING_SOURCE.Series && dataItem.PublishingSource == PUBLISHING_SOURCE.Series) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.you_are_not_authorized_to_attach_contract_please_go_to_parent_series_error_message });
      return;
    }
    if (props?.publishingSource != PUBLISHING_SOURCE.Season && dataItem.PublishingSource == PUBLISHING_SOURCE.Season) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.you_are_not_authorized_to_attach_contract_please_go_to_series_error_message });
      return;
    }
    if (dataItem.PublishingSource != PUBLISHING_SOURCE.Contract) {
      selectedItemsRef.current = [dataItem];
      setShowContractAttachForm(true);
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.you_are_not_authorized_to_attach_contract_please_go_to_contract_error_message });
    }
  }

  const onEditBlackOutDate = (dataItem) => {
    let item = {
      ...dataItem,
      Days: dataItem.Days ? dataItem.Days.split(",").map((item) => DAYS.find((x) => x.ID == item)) : []
    }
    selectedItemsRef.current = [item];
    setShowBlackOutDate(true);
  }

  const MyBlackoutCountCell = (props) => {
    const value = props.dataItem?.BlackOutDates || [];
    const count = Array.isArray(value) ? value.length : 0;
    return (
      <td colSpan={props.colSpan} role="gridcell" aria-colindex={props.ariaColumnIndex} aria-selected={props.isSelected} {...props.tdProps} title={props.tooltip}
        onClick={(e) => { e.stopPropagation(); if (count) { onEditBlackOutDate(props.dataItem); } }}
        style={{ cursor: count ? "pointer" : "default", color: count ? "#0d6efd" : "#6c757d", textDecoration: count ? "underline" : "none", fontWeight: 500 }}>
        <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", padding: "6px 8px", boxSizing: "border-box" }}>
          {count}
        </div>
      </td>
    );
  };

  const MyCommandCell = (props) => (
    <MenuCommandCell
      {...props}
      onEdit={editFormGrid}
      onAttachContract={onAttachContract}
      onDelete={() => ConfirmDeleteAlert(() => removePublishing(props.dataItem), () => { })}
      myMenuModel={dealRightsMenuModel}
      onEditBlackOutDate={onEditBlackOutDate}
    />
  )

  const allDaySelect = (e) => {
    if (e.target.checked) {
      setDataItem({ ...dataItem, Days: DAYS });
      setSelectAllDays(true);
    }
    else {
      setDataItem({ ...dataItem, Days: [] });
      setSelectAllDays(false);
    }
  }

  const MyContractStatusCell = (props) => {

    const currDate = moment.utc().valueOf();

    const publishStartDate = props?.dataItem?.PublishStartDate;
    const publishEndDate = props?.dataItem?.PublishEndDate;

    let value = "In-Active";

    // Active
    if (
      publishStartDate &&
      publishEndDate &&
      currDate >= publishStartDate &&
      currDate <= publishEndDate
    ) {
      value = "Active";
    }

    // Upcoming
    else if (
      publishStartDate &&
      currDate < publishStartDate
    ) {
      value = "Upcoming";
    }

    let backgroundColor = "red";

    if (value === "Active") {
      backgroundColor = "#2ba666";
    } else if (value === "Upcoming") {
      backgroundColor = "#f5a623";
    }

    const newStyle = {
      ...props.style,
      padding: "2px 3px 0px 3px",
      backgroundColor,
      height: "23px",
      borderRadius: "4px",
      textAlign: "center",
      fontWeight: "normal",
      color: "white",
      fontSize: "12px",
      verticalAlign: "center",
      fontFamily: "Roboto",
      letterSpacing: "0.6px",
      margin: "0px",
    };

    return (
      <td
        colSpan={props.colSpan}
        role={"gridcell"}
        aria-colindex={props.ariaColumnIndex}
        aria-selected={props.isSelected}
        {...{
          [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex,
        }}
        {...useTableKeyboardNavigation(props.id)}
        style={props.style}
      >
        <p style={newStyle}>{value}</p>
      </td>
    );
  };

  const handleChannelGroups = (groups = []) => {

    const linkedChannels = groups.flatMap(g => g.LinkedChannels || []);

    const uniqueChannels = Array.from(
      new Map(linkedChannels.map(ch => [ch._id, ch])).values()
    );

    setDataItem(prev => ({
      ...prev,
      Channel: uniqueChannels
    }));
    setSelectAllChannels(uniqueChannels.length === channels.length);

    setShowChannelGroups(false);
  };

  const handlePlatformGroups = (groups = []) => {

    const linkedPlatforms = groups.flatMap(g => g.LinkedPlatforms || []);
    const uniquePlatforms = Array.from(
      new Map(linkedPlatforms.map(pl => [pl._id, pl])).values()
    )

    setDataItem(prev => ({ ...prev, Platform: uniquePlatforms }));
    setShowPlatformGroups(false);
  };

  const handleAttachContract = async (dataList = []) => {
    const contractValue = dataList?.length > 0 ? dataList[0] : {};
    const res = await API.attachContractWithDealRights(contractValue?._id, selectedItemsRef.current?.map(m => m._id));
    console.log(res);
    if (res.success) {
      setGridDealRights(gridDealRights.map(x => {
        if (x?._id == res?.data?.[0]?._id) {
          return res.data[0];
        } else {
          return x;
        }
      }));
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }
    setShowContractAttachForm(false);
  }

  return (<>
    <div style={{ boxShadow: "0px 0px 10px 1px lightgrey", backgroundColor: "#EEEEEE", borderRadius: "10px", width: isLongUI ? "100%" : "" }}>
      <div className="row" style={{ margin: "0px" }}>
        <div className={"col-12"}>
          <Box sx={{ width: '100%', typography: 'body1' }}>
            <TabContext value={tabNumber}>
              <Box sx={{ display: 'flex', borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                  {showLinearTab && <Tab label={lang.linear_label} value="1" />}
                  {isLongUI && showNonLinearTab && <Tab label={lang.non_linear_label} value={"2"} />}
                </TabList>
              </Box>
              {showLinearTab && <TabPanel value={"1"}>
                <div className="row">
                  <div className="col-12" style={{ width: '45vw' }}>
                    <AddRoundButton onClick={() => props.setOpenPublishingDialog(true)} />
                    {isSystemCreated && gridDealRights.length == 0 && <RoundButton title={lang.add_channel_rights_button_tooltip} icon="caret-square-o-right" style={{ float: "right" }} onClick={() => { editFormGrid(systemDealRight); setIsSystemCreatedCheck(true); }} />}
                    <Grid data={gridDealRights.filter((x) => x.PlatformType?.SID == VERSION_TYPE.Linear)} style={{ height: "30vh", marginTop: '5px', display: 'flex' }} resizable={true}>
                      <GridNoRecords> {systemDealRightMessage} </GridNoRecords>
                      <GridColumn cell={MyCommandCell} width={"60px"} />
                      <GridColumn field="Channel" format="FullChannelName" cell={ArrayCell} title={lang.channel_column} width={"250px"} />
                      <GridColumn field='PublishingSource' title={lang.source_column} width={"150px"} />
                      {isLongUI && <GridColumn field='ContractNumber' title={lang.contract_number_column} cell={HrefCell} width={"150px"} />}
                      <GridColumn field="PublishStartDate" title={lang.start_date_column} cell={DateTimeCell} width={"200px"} />
                      <GridColumn field="PublishEndDate" title={lang.end_date_column} cell={DateTimeCell} width={"200px"} />
                      <GridColumn field="BlackOutDates" title={lang.blackout_column} cell={MyBlackoutCountCell} width={"200px"}/>
                      {isLongUI && <GridColumn field="IsUnlimited" title={lang.is_unlimited_column} cell={CheckboxCell} width={"120px"} />}
                      {isLongUI && <GridColumn field="Exhibitions" title={lang.exhibition_column} width={"150px"} />}
                      {isLongUI && <GridColumn field="Repeats" title={lang.repeat_column} width={"150px"} />}
                      {isLongUI && <GridColumn field="PlayTimeNumber" title={lang.play_time_number_column} width={"150px"} />}
                      {isLongUI && <GridColumn field="PlayTime.Description" title={lang.playTime_column} width={"150px"} />}
                      {isLongUI && <GridColumn field="IsExclusive" title={lang.is_exclusive_column} cell={CheckboxCell} width={"120px"} />}
                      {isLongUI && <GridColumn field="ExclusiveStartDate" title={lang.exclusive_start_date_column} cell={DateOnlyCell} width={"150px"} />}
                      {isLongUI && <GridColumn field="ExclusiveEndDate" title={lang.exclusive_end_date_column} cell={DateOnlyCell} width={"150px"} />}
                      {!isLongUI && <GridColumn field="TBA" title={lang.tba_column} editor="boolean" editable={false} cell={CheckboxCell} width={"120px"} />}
                      {!isLongUI && <GridColumn field="Days" title={lang.days_column} cell={(props) => stringEnumCell(props, DAYS, "SubName")} width={"200px"} />}
                      <GridColumn field="addBy.name" title={'Added By'} width={'125px'} />
                      <GridColumn field="modBy.name" title={'Modified By'} width={'125px'} />
                    </Grid>
                  </div>
                </div>
              </TabPanel>}
              {isLongUI && showNonLinearTab && <TabPanel value={"2"}>
                <div className="row">
                  <div className="col-12" style={{ width: '45vw' }}>
                    <AddRoundButton onClick={() => props.setOpenPublishingDialog(true)}></AddRoundButton>
                    <Grid data={gridDealRights.filter((x) => x.PlatformType?.SID == VERSION_TYPE.NonLinear)} style={{ height: "30vh", marginTop: '5px' }} resizable={true}>
                      <GridColumn cell={MyCommandCell} width={"80px"} locked={true} />
                      <GridColumn field="Platform" format="Description" cell={ArrayCell} title={lang.platform_column} width={"320px"} />
                      <GridColumn field='PublishingSource' title={lang.source_column} width={"150px"} />
                      <GridColumn field="ContractNumber" title={lang.contract_number_label} cell={HrefCell} width={"150px"} />
                      <GridColumn field="Status" title={lang.status_column} cell={MyContractStatusCell} width={"150px"} />
                      <GridColumn field="PublishStartDate" title={lang.start_date_column} cell={DateOnlyCell} width={"120px"} />
                      <GridColumn field="PublishEndDate" title={lang.end_date_column} cell={DateOnlyCell} width={"120px"} />
                      <GridColumn field="PremierStartDate" title={lang.premier_start_date_column} cell={DateOnlyCell} width={"120px"} />
                      <GridColumn field="PremierEndDate" title={lang.premier_end_date_column} cell={DateOnlyCell} width={"120px"} />
                      <GridColumn field="TransmissionType.Name" title={lang.transmission_type_column} width={"120px"} />
                      <GridColumn field="Runs" title={lang.runs_column} width={"100px"} />
                      <GridColumn field="addBy.name" title={'Added By'} width={'125px'} />
                      <GridColumn field="modBy.name" title={'Modified By'} width={'125px'} />
                    </Grid>
                  </div>
                </div>
              </TabPanel>}
            </TabContext>
          </Box>
        </div>

        {/* Form */}
        {props.openPublishingDialog &&
          <BossDialog
            title={lang.publishing_dialog_header}
            onClose={clearData}
            width={isLongUI ? "1000px" : "700px"}
          >
            <SaveButton style={{ marginLeft: '0px' }} onClick={() => onSave()} />
            <CancelButton name={lang.cancel_button_text} btnColor={'danger'} onClick={clearData} />

            {props.isNewMedia && <span >
              <input type={"checkbox"} name={"IsDefault"}
                onChange={(e) => onChange(e)}
                value={dataItem.IsDefault}
                checked={dataItem.IsDefault}
                style={{ margin: "5px 0px 0px 25px", width: '15px', height: '15px' }}
                title="Set default deal right for future use"
              />
              <label className="pl-1 " style={{ fontWeight: "bold" }} title="Set default deal right for future use" >{lang.set_as_default_label}</label>
            </span>}

            <div className="row">
              <div className="col-12 mt-4" >
                {isLongUI && <div className="row form-group">
                  <div className="col-6">
                    <label htmlFor="TabView">{lang.platform_type_label} *</label><br />
                    <DropDownList
                      style={{ backgroundColor: "white" }}
                      data={PLATFORMTYPE}
                      name="PlatformType"
                      textField="Description"
                      dataItemKey="SID"
                      value={dataItem.PlatformType}
                      onChange={onChange}
                      disabled
                    />
                  </div>
                  <div className="col-6">
                    {!isLongUI ? <>
                      <label htmlFor="">{lang.contract_number_label} *</label>
                      <input
                        style={{ height: "35px" }}
                        type="input"
                        className="form-control form-control-sm"
                        name="ContractNumber"
                        value={dataItem.ContractNumber}
                        onChange={(e) => onChange(e)}
                      />
                    </> : <>
                      <label htmlFor="">{lang.minimum_gap_label} </label>
                      <input
                        // style={{ height: "35px" }}
                        type="Number"
                        className="form-control form-control-sm"
                        name="MinGap"
                        value={dataItem.MinGap}
                        onChange={(e) => onChange(e)}
                        min={0}
                      />
                    </>}
                  </div>
                </div>}

                <div className="row">
                  {dataItem.PlatformType?.Description == PLATFORMTYPE[0].Description ? (<>
                    <div className="col-6 form-group">
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <label className="mb-0 fw-semibold">
                          {lang.channel_label} <span className="text-danger">*</span>
                        </label>
                        <div className="d-flex align-items-center">
                          <span className="me-1">{lang.select_all_label}</span>
                          <input
                            type="checkbox"
                            name="IsAllChannels"
                            className="ml-1"
                            value={selectAllChannels}
                            checked={selectAllChannels}
                            onChange={onChange}
                          />
                        </div>
                      </div>
                      <div className="d-flex align-items-center">
                        <div style={{ flex: 1 }}>
                          <MyMultiSelect
                            style={{ backgroundColor: "white", width: "100%" }}
                            data={channels}
                            name="Channel"
                            textField="FullChannelName"
                            dataItemKey="_id"
                            value={dataItem.Channel}
                            onChange={onChange}
                          />
                        </div>
                        <button
                          type="button"
                          className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-success ms-2"
                          style={{ width: "28px", height: "28px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, marginLeft: "10px" }}
                          title={lang.select_channel_groups_tooltip}
                          onClick={() => setShowChannelGroups(true)}
                        >
                          <i className="fa fa-ellipsis-h" aria-hidden="true" />
                        </button>
                      </div>
                    </div>
                    {!isLongUI && <div className="col-6">
                      <label htmlFor="">{lang.days_label} *</label>
                      <span className="float-right">{lang.select_all_label}
                        <input
                          type={"checkbox"}
                          name={"SelectAll"}
                          className="ml-1"
                          onChange={allDaySelect}
                          checked={selectAllDays}
                          value={selectAllDays}
                        />
                      </span>
                      <MyMultiSelect
                        style={{ backgroundColor: "white" }}
                        data={DAYS}
                        name="Days"
                        textField="Name"
                        dataItemKey="ID"
                        value={dataItem.Days}
                        onChange={onChange}
                      />
                    </div>}  </>) : (

                    <div className="col-6 form-group">
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <label className="mb-0 fw-semibold">{lang.platform_label}</label>
                        <div className="d-flex align-items-center">
                          <span className="me-1">{lang.select_all_label}</span>
                          <input
                            type="checkbox"
                            name="IsAllPlatforms"
                            className="ml-1"
                            value={selectAllPlatforms}
                            checked={selectAllPlatforms}
                            onChange={onChange}
                          />
                        </div>
                      </div>
                      <div className="d-flex align-items-center">
                        <div style={{ flex: 1 }}>
                          <MyMultiSelect
                            style={{ backgroundColor: "white" }}
                            data={platforms}
                            name="Platform"
                            textField="Description"
                            dataItemKey="_id"
                            value={dataItem.Platform}
                            onChange={onChange}
                          />
                        </div>
                        <button
                          type="button"
                          className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-success ms-2"
                          style={{ width: "28px", height: "28px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, marginLeft: "10px" }}
                          title={lang.select_program_groups_tooltip}
                          onClick={() => setShowPlatformGroups(true)}
                        >
                          <i className="fa fa-ellipsis-h" aria-hidden="true" />
                        </button>
                      </div>
                    </div>
                  )}

                  {isLongUI && <div className="col-6 form-group">
                    <label htmlFor="TabView">{lang.region_label}</label><br />
                    <MyMultiSelect
                      style={{
                        backgroundColor: "white",
                      }}
                      textField="Description"
                      dataItemKey="_id"
                      data={regions}
                      name="Region"
                      value={dataItem.Region}
                      onChange={onChange}
                      disabled={isSystemCreatedCheck}
                    />
                  </div>}
                </div>

                <div className="row form-group">
                  <div className="col-6">
                    <label htmlFor="">{lang.start_date_label} *</label>
                    <input
                      type="datetime-local"
                      className="form-control form-control-sm"
                      name="PublishStartDate"
                      value={dataItem.PublishStartDate}
                      onChange={(e) => onChange(e)}
                      disabled={isSystemCreatedCheck}
                    />
                  </div>

                  <div className="col-6">
                    <label htmlFor="">{lang.end_Date_label} *</label>
                    <input
                      disabled={dataItem.TBA || isSystemCreatedCheck}
                      type="datetime-local"
                      className="form-control form-control-sm"
                      name="PublishEndDate"
                      value={dataItem.PublishEndDate}
                      onChange={(e) => onChange(e)}
                    />
                  </div>
                </div>

                {dataItem.PlatformType?.Description == PLATFORMTYPE[1].Description &&
                  <div className="row form-group">
                    <div className="col-3">
                      <label htmlFor="">{lang.premier_start_date_label} *</label>
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        name="PremierStartDate"
                        value={dataItem.PremierStartDate}
                        onChange={(e) => onChange(e)}
                        disabled={isSystemCreatedCheck}
                      />
                    </div>

                    <div className="col-3">
                      <label htmlFor="">{lang.premier_end_date_label} *</label>
                      <input
                        disabled={dataItem.TBA || isSystemCreatedCheck}
                        type="date"
                        className="form-control form-control-sm"
                        name="PremierEndDate"
                        value={dataItem.PremierEndDate}
                        onChange={(e) => onChange(e)}
                      />
                    </div>

                    {/* <div className={dataItem.VODType && dataItem.VODType == VODTYPE.TVOD ? "col-4" : "col-6"}>
                      <label htmlFor="">{lang.VODtype_label} </label>
                      <DropDownList
                        style={{ backgroundColor: 'white', border: '1px solid lightgrey' }}
                        data={Object.keys(VODTYPE).map((item) => ({ Name: item, _id: VODTYPE[item] }))}
                        name={"VODType"}
                        textField="Name"
                        dataItemKey="_id"
                        value={{ _id: dataItem.VODType, Name: utility.getKeyByValue(VODTYPE, dataItem.VODType) }}
                        onChange={onChange}
                      />
                    </div>
                    {dataItem.VODType && dataItem.VODType == VODTYPE.TVOD && <div className="col-2">
                      <label htmlFor="">{lang.runs_label}</label>
                      <input type="number" className="form-control form-control-sm" name="Runs" value={dataItem.Runs} onChange={(e) => onChange(e)} min={0} />
                    </div>} */}

                    <div className={dataItem?.TransmissionType?.Name?.toLowerCase() === "tvod" ? "col-4" : "col-6"}>
                      <label htmlFor="">{lang.transmission_type_label} </label>
                      <DropDownList
                        style={{ backgroundColor: 'white', border: '1px solid lightgrey' }}
                        data={transmissionTypes}
                        name="TransmissionType"
                        textField="Name"
                        dataItemKey="_id"
                        value={dataItem.TransmissionType}
                        onChange={onChange}
                      />
                    </div>
                    {dataItem?.TransmissionType?.Name?.toLowerCase() === "tvod" && <div className="col-2">
                      <label htmlFor="">{lang.runs_label}</label>
                      <input type="number" className="form-control form-control-sm" name="Runs" value={dataItem.Runs} onChange={(e) => onChange(e)} min={0} />
                    </div>}
                  </div>}

                {dataItem.TimeBound && <div className="row form-group">
                  <div className="col-6">
                    <label htmlFor="">{lang.from_time_label} *</label>
                    <TimePickerWithFormat
                      className="form-control form-control-sm"
                      name="PublishStartDateTime"
                      value={dataItem.PublishStartDateTime}
                      onChange={(e) => onChange(e)}
                    />
                  </div>

                  <div className="col-6">
                    <label htmlFor="">{lang.to_time_label} *</label>
                    <TimePickerWithFormat
                      className="form-control form-control-sm"
                      name="PublishEndDateTime"
                      value={dataItem.PublishEndDateTime}
                      onChange={(e) => onChange(e)}
                    />
                  </div>
                </div>}
                <div className="row form-group">
                  {dataItem.PlatformType?.Description == PLATFORMTYPE[0].Description && isLongUI && <div className="col-3">
                    <input type={"checkbox"} name={"IsUnlimited"}
                      onChange={(e) => onChange(e)}
                      value={dataItem.IsUnlimited}
                      checked={isSystemCreatedCheck ? true : dataItem.IsUnlimited}
                      disabled={isSystemCreatedCheck}
                    />
                    <label className="pl-1">{lang.is_unlimited_label}</label>
                  </div>}
                  <div className="col-3">
                    <input name="TBA" type="checkbox" value={dataItem.TBA} checked={dataItem.TBA} onChange={onChange} />
                    <label className='ml-1'>{lang.tba_label}</label>
                  </div>
                  {dataItem.PlatformType?.Description == PLATFORMTYPE[0].Description && isLongUI && <div className="col-3">
                    <input type={"checkbox"} name={"TimeBound"}
                      onChange={(e) => onChange(e)}
                      value={dataItem.TimeBound}
                      checked={dataItem.TimeBound}
                    />
                    <label className="pl-1">{lang.time_bound_label}</label>
                  </div>}
                  {dataItem.PlatformType?.Description == PLATFORMTYPE[0].Description && <div className="col-3">
                    <input type={"checkbox"} name={"IsExclusive"}
                      onChange={(e) => onChange(e)}
                      value={dataItem.IsExclusive}
                      checked={dataItem.IsExclusive}
                      disabled={isSystemCreatedCheck}
                    />
                    <label className="pl-1">{lang.exclusive_label}</label>
                  </div>}
                </div>

                <div className="row">
                  <div className="col-6">
                    {dataItem.PlatformType?.Description == PLATFORMTYPE[0].Description && isLongUI && !dataItem.IsUnlimited && <div className="row">
                      <div className="col-6">
                        <label htmlFor="">{lang.exhibition_label} *</label>
                        <TooltipInfoCard message={lang.number_of_exhibition_available_tooltip_message} />
                        <input
                          disabled={dataItem.IsUnlimited}
                          style={{ height: "35px" }}
                          type="number"
                          className="form-control form-control-sm"
                          name="Exhibitions"
                          value={dataItem.Exhibitions}
                          onChange={(e) => onChange(e)}
                        />
                      </div>

                      <div className="col-6">
                        <label htmlFor="">{lang.repeat_label} *</label>
                        <TooltipInfoCard message={lang.number_of_repeat_telecast_available_tooltip_message} />
                        <input
                          disabled={dataItem.IsUnlimited}
                          style={{ height: "35px" }}
                          type="number"
                          className="form-control form-control-sm"
                          name="Repeats"
                          value={dataItem.Repeats}
                          onChange={(e) => onChange(e)}
                        />
                      </div>
                      <div className="col-6 mt-2">
                        <label htmlFor="TabView">{lang.playTime_label} *</label>
                        <TooltipInfoCard message={lang.playtime_tooltip_message} />
                        <DropDownList
                          disabled={dataItem.IsUnlimited}
                          style={{ backgroundColor: "white" }}
                          data={playTime}
                          name="PlayTime"
                          textField="Description"
                          dataItemKey="_id"
                          value={dataItem.PlayTime}
                          onChange={onChange}
                        />
                      </div>
                      <div className="col-6 mt-2">
                        <label htmlFor="">{lang.play_time_number_label} *</label>
                        <TooltipInfoCard message={lang.playtime_number_tooltip_message} />
                        <input
                          disabled={dataItem.IsUnlimited}
                          style={{ height: "35px" }}
                          type="number"
                          className="form-control form-control-sm"
                          name="PlayTimeNumber"
                          value={dataItem.PlayTimeNumber}
                          onChange={(e) => onChange(e)}
                        />
                      </div>
                    </div>}
                  </div>
                  <div className="col-6">
                    <div className="row">
                      {dataItem.IsExclusive && <div className="col-6">
                        <label htmlFor="">{lang.start_date_label} *</label>
                        <input type={'date'} name={"ExclusiveStartDate"} value={dataItem.ExclusiveStartDate} onChange={onChange} max={dataItem.ExclusiveEndDate} className="form-control-sm"
                          style={{ width: '100%', backgroundColor: 'white', border: '1px solid lightgrey', borderRadius: '5px', paddingLeft: '5px' }} label={lang.start_date_label}
                        />
                      </div>}

                      {dataItem.IsExclusive && <div className="col-6">
                        <label htmlFor="">{lang.end_Date_label} *</label>
                        <input type={'date'} name={"ExclusiveEndDate"} onChange={onChange} value={dataItem.ExclusiveEndDate} min={dataItem.ExclusiveStartDate} className="form-control-sm"
                          style={{ width: '100%', backgroundColor: 'white', border: '1px solid lightgrey', borderRadius: '5px', paddingLeft: '5px' }} label={lang.end_Date_label}
                        />
                      </div>}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </BossDialog>}

        {/* Collection */}
        {showChannelGroups && <CollectionSelection setDataList={handleChannelGroups} closeForm={() => setShowChannelGroups(false)} entityname={ENTITYNAME.ChannelGroups} width={"50vw"} title={lang.select_channel_groups_collection_header} addButtonTitle={lang.select_collection_button_text} />}
        {showPlatformGroups && <CollectionSelection setDataList={handlePlatformGroups} closeForm={() => setShowPlatformGroups(false)} entityname={ENTITYNAME.PlatformGroups} width={"50vw"} title={lang.select_platform_groups_collection_header} addButtonTitle={lang.select_collection_button_text} />}
        {showContractAttachForm && <CollectionSelection setDataList={handleAttachContract} closeForm={() => setShowContractAttachForm(false)} entityname={ENTITYNAME.Contract} width={"50vw"} title={lang.select_contract_collection_header} addButtonTitle={lang.select_button_text} mode="single" />}
        {showBlackOutDate && <ContractTitleBlackoutDateEditForm data={{...selectedItemsRef.current[0]}} onCancel={() => setShowBlackOutDate(false)} publishingSource={props.publishingSource} setBlackOutDate={setBlackOutDate} />}

      </div>
    </div>
  </>)
}

export default MediaEpisodePublishingEditForm;